(function() {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function money(cents, format) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, format);
    }
    return cents;
  }

  var isSyncingVariantPickers = false;

  function getMainVariantPicker() {
    return document.querySelector('.product-information variant-selects');
  }

  function getStickyVariantPicker() {
    return document.querySelector('.stickyaddtocart variant-selects');
  }

  function findChoice(el, value) {
    var controls = el.children;
    for (var i = 0; i < controls.length; i++) {
      if (controls[i].value === value) return controls[i];
    }
    return null;
  }

  function syncPickerToVariant(picker, variant) {
    if (!picker || !variant || !variant['options']) return;

    var changed = false;
    variant['options'].forEach(function(value, index) {
      var el = picker.querySelector('[data-index="' + 'option' + (index + 1) + '"]');
      if (!el) return;

      var select = el.querySelector('select');
      if (select) {
        if (select.value !== value) {
          select.value = value;
          changed = true;
        }
        return;
      }

      var input = findChoice(el, value);
      if (input && !input.checked) {
        input.checked = true;
        changed = true;
      }
    });

    if (!changed) return;

    isSyncingVariantPickers = true;
    picker.dispatchEvent(new Event('change', { bubbles: true }));
    isSyncingVariantPickers = false;
  }

  document.addEventListener('product:variant-change', function(e) {
    if (!e.detail || !e.detail.variant) return;
    if (!isSyncingVariantPickers) {
      var sourcePicker = e.detail.source;
      var sourceIsSticky = sourcePicker && sourcePicker.closest && sourcePicker.closest('.stickyaddtocart');
      var targetPicker = sourceIsSticky
        ? getMainVariantPicker()
        : getStickyVariantPicker();

      if (!sourcePicker) {
        targetPicker = e.detail.sectionId && e.detail.sectionId.length > 0
          ? getStickyVariantPicker()
          : getMainVariantPicker();
      }
      syncPickerToVariant(targetPicker, e.detail.variant);
    }

    var compareAtPriceElem = document.querySelector('.stickyaddtocart #price- > span > del > span > span') ||
      document.querySelector('.stickyaddtocart #price- > span > del > span');
    var priceElem = document.querySelector('.stickyaddtocart #price- > span > ins > span > span') ||
      document.querySelector('.stickyaddtocart #price- > span > ins > span');
    var afterPayPriceElem = document.querySelector('.product-information--inner #afterpay-price .money') ||
      document.querySelector('.product-information--inner #afterpay-price');
    var priceFormat = window.theme && window.theme.settings ? window.theme.settings.money_with_currency_format : undefined;

    if (compareAtPriceElem) compareAtPriceElem.innerHTML = money(e.detail.variant.compare_at_price, priceFormat);
    if (priceElem) priceElem.innerHTML = money(e.detail.variant.price, priceFormat);

    var stickyAfterpay = document.querySelector('.stickyaddtocart #afterpay-price');
    if (stickyAfterpay) stickyAfterpay.innerHTML = money(e.detail.variant.price / 4.0, priceFormat);
    if (afterPayPriceElem) afterPayPriceElem.innerHTML = money(e.detail.variant.price / 4.0, priceFormat);
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.afterpay-action')) return;
    document
      .querySelector('square-placement')
      ?.shadowRoot
      ?.querySelector('button.afterpay-logo')
      ?.click();
  });

  document.addEventListener('cart:line-item:removed', function(e) {
    document.querySelector('#Cart-Drawer')?.updateQuantity(e.detail.target.dataset.index, '0');
  });

  function initializeCountdown() {
    var countdownElement = document.getElementById('countdown');
    if (!countdownElement) return;

    var targetDate = countdownElement.getAttribute('data-target-date');
    var countdownHours = countdownElement.getAttribute('data-target-hours');
    var targetTime;

    if (targetDate) {
      targetTime = new Date(targetDate).getTime();
    } else if (countdownHours) {
      var today = new Date();
      var dynamicDate = today.getFullYear() + '-' +
        (today.getMonth() + 1).toString().padStart(2, '0') + '-' +
        today.getDate().toString().padStart(2, '0') + 'T23:59:59';
      targetTime = new Date(dynamicDate).getTime();
    } else {
      return;
    }

    function updateCountdown() {
      var now = Date.now();
      var timeRemaining = targetTime - now;

      if (timeRemaining >= 0) {
        var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
        var hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24).toString().padStart(2, '0');
        var minutes = Math.floor((timeRemaining / (1000 * 60)) % 60).toString().padStart(2, '0');
        var seconds = Math.floor((timeRemaining / 1000) % 60).toString().padStart(2, '0');

        countdownElement.innerHTML =
          '<strong>' + days + '</strong> Day <span>:</span>' +
          '<strong>' + hours + '</strong> Hrs <span>:</span>' +
          '<strong>' + minutes + '</strong> Mins <span>:</span>' +
          '<strong>' + seconds + '</strong> Sec';

        window.setTimeout(updateCountdown, 1000);
      }
    }

    updateCountdown();
  }

  window.initializeCountdown = initializeCountdown;

  window.openTab = function(tabId) {
    document.querySelectorAll('.cstm-tabs-btn').forEach(function(btn) {
      btn.classList.remove('active');
    });
    document.querySelectorAll('.cstm-tabs-content').forEach(function(content) {
      content.classList.remove('active');
    });

    var button = document.querySelector(".cstm-tabs-btn[onclick=\"openTab('" + tabId + "')\"]");
    var content = document.getElementById(tabId);
    if (button) button.classList.add('active');
    if (content) content.classList.add('active');
  };

  function responsiveMove(elementSelector, targetSmallScreenSelector, targetLargeScreenSelector, breakpoint, position) {
    var element = document.querySelector(elementSelector);
    var targetSmallScreen = document.querySelector(targetSmallScreenSelector);
    var targetLargeScreen = document.querySelector(targetLargeScreenSelector);
    if (!element || !targetSmallScreen || !targetLargeScreen) return;

    var target = breakpoint >= window.innerWidth ? targetSmallScreen : targetLargeScreen;
    var referenceNode = position === 'before' ? target : target.nextSibling;
    var desiredNextEl = position === 'before' ? target : target.nextElementSibling;
    if (element.nextElementSibling === desiredNextEl) return;
    target.parentNode.insertBefore(element, referenceNode);
  }

  function moveCriticalProductElements() {
    responsiveMove('.pfp-features', '.pdp-badges', 'variant-selects', 767, 'before');
  }

  function forceOpenCartDrawer() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;

    drawer.removeAttribute('closing');
    drawer.classList.remove('is-closing');
    drawer.classList.remove('closing');
    drawer.open();

    window.setTimeout(function() {
      if (!drawer.hasAttribute('open')) drawer.open();
    }, 120);
  }

  window.initiateFlicktyInDrawer = function() {
    var blocks = document.querySelectorAll('.icon-block').length;
    var wrappers = document.querySelectorAll('.icons-container .content-wrapper');
    if (!wrappers.length) return;

    function init() {
      if (typeof Flickity !== 'function') return;

      if (blocks > 1) {
        wrappers.forEach(function(wrapper) {
          if (Flickity.data && Flickity.data(wrapper)) return;
          new Flickity(wrapper, {
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,

            autoPlay: 3000,

            wrapAround: true
          });
        });
      } else {
        wrappers[0].classList.add('center');
      }
    }

    if (typeof Flickity === 'function') {
      init();
    } else if (window.theme && typeof window.theme.loadVendor === 'function') {
      window.theme.loadVendor().then(init);
    }
  };

  onReady(function() {
    initializeCountdown();
    moveCriticalProductElements();

    var squarePlacement = document.querySelector('square-placement');
    var productPriceContainer = document.querySelector('.stickyaddtocart .product-price-container');
    if (squarePlacement && productPriceContainer) {
      productPriceContainer.appendChild(squarePlacement.cloneNode(true));
    }

    var textButtons = document.querySelectorAll('.template-product .text-button');
    var productATC = document.querySelector('.product button#AddToCart');
    if (textButtons.length > 0 && productATC) {
      textButtons.forEach(function(textButton) {
        textButton.addEventListener('click', function(e) {
          e.preventDefault();
          textButton.classList.add('loading');

          var variantId = productATC.getAttribute('data-vid');
          if (!variantId) {
            textButton.classList.remove('loading');
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
            .then(function(response) {
              if (!response.ok) throw new Error('Error adding item to cart');
              return response.json();
            })
            .then(function() {
              textButton.classList.remove('loading');
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              if (document.getElementById('Cart-Drawer')) {
                window.initiateFlicktyInDrawer();
                if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open');
                document.getElementById('Cart-Drawer').open();
                window.setTimeout(window.initiateFlicktyInDrawer, 600);
              }
            })
            .catch(function() {
              textButton.classList.remove('loading');
            });
        });
      });
    }

    var addToCartBtn = document.querySelector('#AddToCart');
    var stickyAddToCartBtn = document.querySelector('#sticky-add-to-cart-button');
    var variantSelectors = document.querySelectorAll('form[action="/cart/add"] select, form[action="/cart/add"] input[type="radio"]');
    var stickyVariantOptions = document.querySelector('#sticky-variant-options');

    function syncMainVariant(event) {
      var target = event.target;
      var mainSelector = document.querySelector('[name="' + target.name + '"]');
      if (mainSelector) {
        mainSelector.value = target.value;
        mainSelector.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (stickyVariantOptions) {
      variantSelectors.forEach(function(selector) {
        var clone = selector.cloneNode(true);
        clone.addEventListener('change', syncMainVariant);
        stickyVariantOptions.appendChild(clone);
      });
    }

    if (stickyAddToCartBtn && addToCartBtn) {
      stickyAddToCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = addToCartBtn.getAttribute('data-vid');
        if (!variantId) return;

        stickyAddToCartBtn.classList.add('loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function(res) { return res.json(); })
          .then(function() {
            stickyAddToCartBtn.classList.remove('loading');
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open');
            forceOpenCartDrawer();
            window.setTimeout(window.initiateFlicktyInDrawer, 600);
          })
          .catch(function() {
            stickyAddToCartBtn.classList.remove('loading');
          });
      });
    }

    var stickyObservedElement = document.querySelector('button#AddToCart.sticky-add-tocart-main');
    var stickyHeaderElement = document.querySelector('theme-header#header');
    var stickyAddToCartBar = document.querySelector('.stickyaddtocart');
    var lastScrollPosition = window.scrollY || 0;
    var stickyAddToCartThreshold = null;
    var stickyAddToCartTicking = false;

    function refreshStickyAddToCartThreshold() {
      if (!stickyObservedElement || !stickyHeaderElement) return;
      stickyAddToCartThreshold = stickyObservedElement.getBoundingClientRect().top + window.scrollY - stickyHeaderElement.offsetHeight;
    }

    function updateStickyAddToCartVisibility() {
      stickyAddToCartTicking = false;
      if (!stickyObservedElement || !stickyHeaderElement || !stickyAddToCartBar) return;
      if (stickyAddToCartThreshold === null) refreshStickyAddToCartThreshold();
      if (stickyAddToCartThreshold === null) return;

      var scrolledPosition = window.scrollY || 0;
      if (scrolledPosition > lastScrollPosition && scrolledPosition > stickyAddToCartThreshold) {
        stickyAddToCartBar.classList.add('active');
      } else if (lastScrollPosition > scrolledPosition) {
        stickyAddToCartBar.classList.remove('active');
      }
      lastScrollPosition = scrolledPosition;
    }

    if (stickyObservedElement && stickyHeaderElement && stickyAddToCartBar) {
      refreshStickyAddToCartThreshold();
      window.addEventListener('load', refreshStickyAddToCartThreshold, { once: true });
      window.addEventListener('resize', function() {
        stickyAddToCartThreshold = null;
        updateStickyAddToCartVisibility();
        moveCriticalProductElements();
      }, { passive: true });
      window.addEventListener('scroll', function() {
        if (stickyAddToCartTicking) return;
        stickyAddToCartTicking = true;
        window.requestAnimationFrame ? window.requestAnimationFrame(updateStickyAddToCartVisibility) : window.setTimeout(updateStickyAddToCartVisibility, 16);
      }, { passive: true });
    }
  });
})();
